import CareLink from "./CareLink.png";
import ShoeBox from "./ShoeBox.png";
import MemeGenerator from "./MemeGenerator.png";
import CarPool from "./CarPool.png";
import Design from "./PortfolioDesign.jpg";
import Tindog from "./Tindog.png";

const Projects_data = [
    {
      id: 1,
      category: "DEVELOPMENT",
      totalLike: "600",
      title: "Pharmaceutical Company Website",
      image: CareLink,
      desc: "CareLink Pharmaceuticals' official website is a dynamic online hub showcasing our cutting-edge pharmaceutical solutions. Powered by HTML, CSS, Bootstrap, JavaScript, and ReactJS, it offers comprehensive insights into our products and services, fostering transparency and accessibility for our valued stakeholders and clients.",
      tech : "Technologies used :  HTML, CSS, Bootstrap, JavaScript , ReactJS , Canva",
      period : "June 2023- July2023",
      link : "https://www.carelinkpharma.in/",
    },
    {
      id: 2,
      category: "DEVELOPMENT",
      totalLike: "750",
      title: "Ecommerce Website",
      image: ShoeBox,
      desc: "Ecommerce Shoes Website, a short-term project launched in April 2023, designed to captivate shoe enthusiasts. Our primary objectives were to create an appealing and user-friendly interface while curating an extensive and diverse collection of footwear. Built using HTML, CSS, and JavaScript, our website strives to provide a seamless shopping experience for all shoe lovers.",
      tech : "Technologies used :  HTML, CSS, JavaScript , Canva",
      period : "April 2023- May 2023",
      link : "https://rugvedgadakh.github.io/Ecommerce-Website/",
    },
    {
      id: 3,
      category: "DEVELOPMENT",
      totalLike: "630",
      title: "CarPool Web Application",
      image: CarPool,
      desc: "Carpool Website, where we're reshaping the future of transportation. Launched in June 2023, our platform is dedicated to fostering eco-conscious and cost-effective commuting through efficient carpooling. By connecting like-minded travelers, we're on a mission to alleviate traffic congestion and reduce carbon emissions, one shared ride at a time.Our user-friendly website, built with HTML, CSS, Bootstrap, and JavaScript, empowers you to find and coordinate rides seamlessly. Whether you're a daily commuter or an occasional traveler, our platform offers a convenient solution to save money, reduce your environmental impact, and make meaningful connections with fellow passengers.",
      tech : "Technologies used :  HTML, CSS, Bootstrap, JavaScript , Canva",
      period : "June 2023- July 2023",
      link : "https://rugvedgadakh.github.io/Pbl_Project/",
    },
    {
      id: 4,
      category: "DEVELOPMENT",
      totalLike: "360",
      title: "Tindog Website",
      image: Tindog,
      desc: "Tindog Website, a project that came to life in September 2022 as part of the Udemy Web Development Bootcamp Course. This delightful website was crafted to sharpen our Bootstrap skills.Built with HTML, CSS, and Bootstrap, Tindog offers a playful twist on the world of online dating but with a focus on connecting dog lovers with their furry companions in mind.",
      tech : "Technologies used :  HTML, CSS, Bootstrap, JavaScript ",
      period : "September 2022- October 2022",
      link : "https://rugvedgadakh.github.io/TinDog/",
    },
    
    {
        id: 5,
        category: "DEVELOPMENT",
        totalLike: "360",
        title: "Meme Generator",
        image: MemeGenerator,
        desc: "Meme Generator Website, a project born in April 2023 and nurtured until June 2023. Our mission was to develop an engaging platform where users can unleash their creativity by crafting and sharing random memes.Powered by HTML, CSS, JavaScript, and APIs, our website offers a fun and user-friendly meme-making experience. Whether you're looking to bring laughter to your friends or express your humor, we've got you covered.",
        tech : "Technologies used :  HTML, CSS, JavaScript ,APIs",
        period : "April 2023- April 2023",
        link : "https://rugvedgadakh.github.io/meme_generator_website/",
      },

      {
        id: 5,
        category: "DESIGN",
        totalLike: "360",
        title: "Posters/Banners & Web Designs",
        image: Design,
        desc: "Passionate and creative designer with a flair for bringing college club events to life through captivating visuals. I specialize in crafting compelling designs that not only catch the eye but also convey the essence of each event. From posters to promotional materials, I've had the privilege of turning concepts into captivating realities, creating memorable experiences for club members and attendees alike. With an eye for detail and a passion for storytelling through design, I'm dedicated to making each event a success. ",
        tech : "Technologies used : Canva",
        period : "2022 - PRESENT",
        link : "https://www.canva.com/design/DAFvhyHjHPE/V2pVUOU8UVO_HVjHqIUZsw/watch?utm_content=DAFvhyHjHPE&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink",
      },


  ]
  export default Projects_data